import { BookingRequestsStatus } from "../../../BookingRequest/typings/booking-requests.types";
import { ServiceType } from "../../../../features/Booking-Form/typings/booking-service-administration.types";
import { DetailedServiceBookingData } from "../Domain/RemoteOrderRequests.types";
import { hasStatusTransitionToApproved } from "./hasStatusTransitionToApproved.function";

export type EditedServiceRecordRow = {
  type: ServiceType;
  id: number;
  status: BookingRequestsStatus;
};

export const computeHasNewlyApprovedServiceOrder = (
  editedData: DetailedServiceBookingData | null,
  editedRecord: readonly EditedServiceRecordRow[],
  detailData: DetailedServiceBookingData
): boolean => {
  if (!editedData) return false;

  const categories = [
    {
      edited: editedRecord.filter(item => item.type === ServiceType.Catering),
      original: detailData.caterings
    },
    {
      edited: editedRecord.filter(item => item.type === ServiceType.Bookable_Equipment),
      original: detailData.equipments
    },
    {
      edited: editedRecord.filter(item => item.type === ServiceType.Room_Layout),
      original: detailData.roomLayouts
    }
  ];

  return categories.some(category =>
    hasStatusTransitionToApproved(category.edited, category.original)
  );
};
